import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { t } from "../i18n";

export default function CTA() {
  const ref = useRef(null);
  const c = t.de.cta;
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="cta" className="relative py-28 md:py-40 overflow-hidden bg-navy-900">
      <motion.div style={{ y }} className="absolute inset-0 opacity-25">
        <img
          src="https://images.pexels.com/photos/11861957/pexels-photo-11861957.jpeg"
          alt=""
          className="w-full h-[130%] object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/85 to-navy-900/70" />
      <div className="absolute -bottom-32 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] bg-gold-500/15 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 md:px-12 max-w-4xl relative text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-white leading-tight text-balance"
        >
          {c.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-6 text-lg md:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed"
        >
          {c.text}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-10"
        >
          <Link
            to="/kontakt"
            data-testid="cta-button"
            className="group inline-flex items-center gap-3 bg-gold-500 text-white rounded-full px-10 py-5 text-lg font-medium transition-all hover:bg-gold-600 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(197,160,89,0.4)]"
          >
            {c.btn}
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
